import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'telefoneFormat'
})
export class TelefoneFormatPipe implements PipeTransform {

  transform(value?: string): string {
    if (!value) {
      return '';
    }
    const digits = value.replace(/\D/g, '');
    const match = digits.match(/^(\d{2})(\d{4,5})(\d{4})$/);

    if (!match) return value;

    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
}
